// Utils and Constants
import { useUrlKeyCheck } from "../../../mavin/utils/hooks/HooksUtil";
import {
  PincodeRankingBlueShades,
  UrlKeys,
} from "../../../constants/GeneralConstants";

// Components
import CardCollapsible from "../../../components/card-collapsible/CardCollapsible";

/**
 * Pincode Ranking Controls Panel
 */
export default function PincodeRankingControlsPanel({ settings = {} }) {
  const { rankedBoundariesPolygonData } = settings || {};
  const { features = [] } = rankedBoundariesPolygonData || {};
  const isDataPresent = features?.length > 0;

  const { campaignPlanning, cityAnalyser } = UrlKeys;
  // plan and city-analyser key will not present in campaign analyser page url
  // so this will return true for campaign planner page and city analyser tool
  // if the plan is present in url then its is from campaign planning page
  const isDisabled = useUrlKeyCheck(campaignPlanning, cityAnalyser);

  return (
    <CardCollapsible
      id="area-ranking-controls"
      header={"Area Ranking Settings"}
      subHeader={`${!isDataPresent ? "No TG Attributes are selected" : ""}`}
      disabled={!isDisabled}
    >
      {isDataPresent && (
        <>
          <p className="sec-title mb-1">Rank Color Indication</p>
          {PincodeRankingBlueShades.map((colorHex, index) => {
            return (
              <div key={index}>
                <span
                  className="border px-4 ml-1 mr-3"
                  style={{ backgroundColor: colorHex }}
                ></span>
                <span>{`Rank ${index + 1}`}</span>
              </div>
            );
          })}
        </>
      )}
    </CardCollapsible>
  );
}
